import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import enhanceWithClickOutside from 'react-click-outside';
import NotificationsBadge from '../NotificationsBadge';
import NotificationsView from '../NotificationsView';
import styles from './NotificationsViewToggler.m.sass';
var NotificationsViewToggler = enhanceWithClickOutside(_class = observer(_class = /*#__PURE__*/function (_React$Component) {
  function NotificationsViewToggler() {
    _classCallCheck(this, NotificationsViewToggler);
    return _callSuper(this, NotificationsViewToggler, arguments);
  }
  _inherits(NotificationsViewToggler, _React$Component);
  return _createClass(NotificationsViewToggler, [{
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.props.store.close();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        store = _this$props.store,
        badgeTop = _this$props.badgeTop,
        badgeLeft = _this$props.badgeLeft,
        viewTop = _this$props.viewTop,
        viewLeft = _this$props.viewLeft;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.root, className)
      }, /*#__PURE__*/React.createElement(NotificationsBadge, {
        count: store.unreadCount,
        top: badgeTop,
        left: badgeLeft
      }), children, /*#__PURE__*/React.createElement(NotificationsView, {
        top: viewTop,
        left: viewLeft,
        store: store
      }));
    }
  }]);
}(React.Component)) || _class) || _class;
export { NotificationsViewToggler as default };
//# sourceMappingURL=index.js.map
